<template>
	<div class="info-wrap">
		<div class="info">
			<svg
				class="desktop"
				width="78"
				height="70"
				viewBox="0 0 78 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M70.0666 63H77.0732V70H0V63H7.00666V3.5C7.00666 2.57174 7.37576 1.6815 8.03276 1.02513C8.68976 0.368749 9.58085 0 10.51 0H66.5632C67.4924 0 68.3835 0.368749 69.0405 1.02513C69.6975 1.6815 70.0666 2.57174 70.0666 3.5V63ZM63.0599 63V7H14.0133V63H63.0599ZM24.5233 31.5H35.0333V38.5H24.5233V31.5ZM24.5233 17.5H35.0333V24.5H24.5233V17.5ZM24.5233 45.5H35.0333V52.5H24.5233V45.5ZM42.0399 45.5H52.5499V52.5H42.0399V45.5ZM42.0399 31.5H52.5499V38.5H42.0399V31.5ZM42.0399 17.5H52.5499V24.5H42.0399V17.5Z"
					fill="#73b3ff"
				/>
			</svg>
			<div class="text">
				<p>
					ENON Solutions is a company specialized in
					<b>software development</b> with a wide range of projects in its
					portfolio, including mobile phone applications, AI, IoT applications,
					as well as web applications.
				</p>
			</div>
		</div>
		<div class="info narrow">
			<svg
				width="74"
				height="70"
				viewBox="0 0 74 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7.37952 70C5.35015 70 3.6135 69.2791 2.16958 67.8374C0.723193 66.3932 0 64.6579 0 62.6316V22.1053C0 20.0789 0.723193 18.3449 2.16958 16.9032C3.6135 15.4589 5.35015 14.7368 7.37952 14.7368H22.1386V7.36842C22.1386 5.34211 22.8617 3.60684 24.3081 2.16263C25.7521 0.720877 27.4887 0 29.5181 0H44.2771C46.3065 0 48.0444 0.720877 49.4907 2.16263C50.9347 3.60684 51.6566 5.34211 51.6566 7.36842V14.7368H66.4157C68.445 14.7368 70.1829 15.4589 71.6293 16.9032C73.0732 18.3449 73.7952 20.0789 73.7952 22.1053V62.6316C73.7952 64.6579 73.0732 66.3932 71.6293 67.8374C70.1829 69.2791 68.445 70 66.4157 70H7.37952ZM7.37952 62.6316H66.4157V22.1053H7.37952V62.6316ZM29.5181 14.7368H44.2771V7.36842H29.5181V14.7368ZM7.37952 62.6316V22.1053V62.6316Z"
					fill="#73b3ff"
				/>
			</svg>

			<div class="text">
				<p>
					Our business analysts, with their experience and knowledge, are at
					your service to evaluate your needs and come up with the most
					efficient tailored solutions.
				</p>
			</div>
		</div>
		<div class="info narrow">
			<svg
				width="70"
				height="70"
				viewBox="0 0 70 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7 59.5V63H70V70H0V0H7V52.5C17.5 52.5 28 45.5 35.35 32.9C45.85 15.4 57.4 7 70 7V14C60.2 14 50.75 21.35 41.65 36.75C32.55 51.1 19.95 59.5 7 59.5Z"
					fill="#73b3ff"
				/>
			</svg>

			<div class="text">
				<p>
					Our specialty is not only building high-quality products but also
					maintaining, expanding, and scaling your projects to satisfy all your
					future needs.
				</p>
			</div>
		</div>
		<div class="info">
			<svg
				width="70"
				height="70"
				viewBox="0 0 70 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12.5125 0.260301C12.9581 0.474499 13.3341 0.810159 13.5973 1.22863C13.8605 1.6471 14.0001 2.13137 14 2.62567C14 5.5299 15.092 7.20245 16.4605 9.23891L16.562 9.38587C17.724 11.1144 19.25 13.3783 19.25 16.6219C19.25 19.9321 17.5805 22.8503 15.036 24.5823C15.7045 25.1422 16.296 25.8315 16.807 26.6573C18.473 29.3516 19.25 33.47 19.25 39.3834C19.25 45.3738 18.445 52.5679 17.1325 58.3134C16.4815 61.1686 15.673 63.8034 14.7105 65.7804C14.2561 66.764 13.6542 67.6726 12.9255 68.4747C12.2045 69.213 11.095 70.0002 9.625 70.0002C8.155 70.0002 7.0455 69.213 6.328 68.4747C5.59724 67.6742 4.99508 66.7653 4.543 65.7804C3.577 63.7999 2.7685 61.1686 2.1175 58.3099C0.752316 52.0911 0.0426087 45.7465 3.37226e-06 39.3799C3.37226e-06 33.4665 0.777003 29.3516 2.443 26.6573C2.91829 25.8752 3.51626 25.1746 4.214 24.5823C2.91471 23.7004 1.85128 22.5138 1.11669 21.1261C0.382088 19.7384 -0.00131182 18.192 3.37226e-06 16.6219C3.37226e-06 15.3343 3.02494e-06 13.1194 1.3405 10.2606C2.653 7.46139 5.1485 4.24574 9.7335 0.575218C10.1199 0.266194 10.5859 0.0726629 11.0776 0.0169438C11.5693 -0.0387754 12.0667 0.0455864 12.5125 0.260301V0.260301ZM5.25 16.6184V16.6219C5.25 17.782 5.71094 18.8945 6.53141 19.7147C7.35188 20.535 8.46468 20.9958 9.625 20.9958C10.7853 20.9958 11.8981 20.535 12.7186 19.7147C13.5391 18.8945 14 17.782 14 16.6219C14 15.0859 13.3525 14.0221 12.103 12.1641L12.061 12.1012C11.2595 10.9115 10.311 9.50134 9.639 7.69232C7.7385 9.62381 6.6885 11.2264 6.097 12.486C5.25 14.2916 5.25 15.5757 5.25 16.615V16.6184ZM6.909 29.4145C6.041 30.8212 5.25 33.7044 5.25 39.3834C5.25 44.9854 6.013 51.7876 7.2345 57.1447C7.8505 59.8389 8.5505 62.0259 9.261 63.4815C9.3905 63.7509 9.513 63.9748 9.625 64.1638C9.737 63.9748 9.8595 63.7509 9.989 63.4815C10.6995 62.0259 11.3995 59.8354 12.0155 57.1447C13.2405 51.7911 14 44.9889 14 39.3834C14 33.7044 13.209 30.8212 12.341 29.4145C12.0792 28.941 11.6835 28.5552 11.2035 28.3053C10.7065 28.0889 10.1667 27.9884 9.625 28.0114C8.925 28.0114 8.4245 28.1199 8.0465 28.3053C7.56646 28.5552 7.17078 28.941 6.909 29.4145V29.4145ZM28 45.2023C26.1457 44.8914 24.342 44.3311 22.638 43.5368C22.7404 41.5522 22.7696 39.5646 22.7255 37.5779C24.304 38.6381 26.0855 39.4184 28 39.8523V29.7435C28 28.3514 28.5531 27.0164 29.5377 26.0321C30.5223 25.0478 31.8576 24.4949 33.25 24.4949H47.25C47.2498 21.5581 46.4281 18.6798 44.8777 16.1854C43.3274 13.6909 41.1101 11.6797 38.4764 10.3788C35.8427 9.07799 32.8976 8.53944 29.9739 8.824C27.0501 9.10857 24.2642 10.2049 21.931 11.9892C21.231 10.0542 20.2335 8.57409 19.5405 7.54536L19.4005 7.33542C22.5451 5.11927 26.2382 3.80936 30.0768 3.54868C33.9153 3.28801 37.7518 4.08659 41.1672 5.85724C44.5827 7.6279 47.446 10.3026 49.4445 13.5893C51.4431 16.876 52.5 20.6485 52.5 24.4949H64.75C66.1424 24.4949 67.4777 25.0478 68.4623 26.0321C69.4469 27.0164 70 28.3514 70 29.7435V61.2351C70 62.6271 69.4469 63.9621 68.4623 64.9464C67.4777 65.9307 66.1424 66.4837 64.75 66.4837H33.25C31.8576 66.4837 30.5223 65.9307 29.5377 64.9464C28.5531 63.9621 28 62.6271 28 61.2351V45.1988V45.2023ZM33.25 45.4228V61.2386H64.75V29.747H51.835C50.7446 33.9634 48.3703 37.7368 45.0408 40.5452C41.7112 43.3536 37.591 45.058 33.25 45.4228V45.4228ZM46.354 29.747H33.25V40.1497C36.1907 39.8201 38.9792 38.6696 41.2966 36.83C43.6139 34.9903 45.3666 32.5357 46.354 29.747V29.747Z"
					fill="#73b3ff"
				/>
			</svg>

			<div class="text">
				<p>
					Our designers are here as well to help you achieve the best possible
					UI/UX experience that will be loved by your users, while our testers
					ensure that your project is rolled out bug-free.
				</p>
			</div>
		</div>
		<div class="info narrow">
			<svg
				width="84"
				height="70"
				viewBox="0 0 84 70"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M27.1833 35L34.0667 29.2639C35 28.4861 35.4667 27.5787 35.4667 26.5417C35.4667 25.5046 35 24.5972 34.0667 23.8194C33.1333 23.0417 32.0258 22.6528 30.744 22.6528C29.4591 22.6528 28.35 23.0417 27.4167 23.8194L17.2667 32.2778C16.8 32.6667 16.4702 33.088 16.2773 33.5417C16.0813 33.9954 15.9833 34.4815 15.9833 35C15.9833 35.5185 16.0813 36.0046 16.2773 36.4583C16.4702 36.912 16.8 37.3333 17.2667 37.7222L27.4167 46.1806C28.35 46.9583 29.4591 47.3472 30.744 47.3472C32.0258 47.3472 33.1333 46.9583 34.0667 46.1806C35 45.4028 35.4667 44.4954 35.4667 43.4583C35.4667 42.4213 35 41.5139 34.0667 40.7361L27.1833 35ZM56.8167 35L49.9333 40.7361C49 41.5139 48.5333 42.4213 48.5333 43.4583C48.5333 44.4954 49 45.4028 49.9333 46.1806C50.8667 46.9583 51.9758 47.3472 53.2607 47.3472C54.5424 47.3472 55.65 46.9583 56.5833 46.1806L66.7333 37.7222C67.2 37.3333 67.5298 36.912 67.7227 36.4583C67.9187 36.0046 68.0167 35.5185 68.0167 35C68.0167 34.4815 67.9187 33.9954 67.7227 33.5417C67.5298 33.088 67.2 32.6667 66.7333 32.2778L56.5833 23.8194C56.1167 23.4306 55.5924 23.1389 55.0107 22.9444C54.4258 22.75 53.8424 22.6528 53.2607 22.6528C52.6758 22.6528 52.0924 22.75 51.5107 22.9444C50.9258 23.1389 50.4 23.4306 49.9333 23.8194C49 24.5972 48.5333 25.5046 48.5333 26.5417C48.5333 27.5787 49 28.4861 49.9333 29.2639L56.8167 35ZM9.33333 70C6.76667 70 4.56867 69.2391 2.73933 67.7172C0.913111 66.1928 0 64.3611 0 62.2222V7.77778C0 5.63889 0.913111 3.80722 2.73933 2.28278C4.56867 0.760925 6.76667 0 9.33333 0H74.6667C77.2333 0 79.4313 0.760925 81.2607 2.28278C83.0869 3.80722 84 5.63889 84 7.77778V62.2222C84 64.3611 83.0869 66.1928 81.2607 67.7172C79.4313 69.2391 77.2333 70 74.6667 70H9.33333ZM9.33333 62.2222H74.6667V7.77778H9.33333V62.2222ZM9.33333 7.77778V62.2222V7.77778Z"
					fill="#73b3ff"
				/>
			</svg>

			<div class="text">
				<p>
					We are proficient in JavaScript, Java, Node.js, and MARS, and we are
					here to pick the right tools for your project. We also offer cloud
					services for our customers and can deploy projects to cloud
					infrastructure.
				</p>
			</div>
		</div>
		<div class="info narrow">
			<svg
				width="737"
				height="646"
				viewBox="0 0 737 646"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_107_159)">
					<path
						d="M535.69 381.84C549.03 381.84 561.79 376.9 571.64 367.94L606.62 336.14C609.09 333.89 612.29 332.65 615.64 332.65H627.03C636.9 352.04 656.88 364.41 678.73 364.41C710.7 364.41 736.71 338.4 736.71 306.44C736.71 274.47 710.7 248.46 678.73 248.46C651.79 248.46 628.68 266.84 622.41 292.67H615.64C602.33 292.67 589.57 297.61 579.71 306.57L544.73 338.37C542.26 340.62 539.05 341.86 535.69 341.86H392.93V306.54H464.46C485.06 306.54 504.47 298.56 519.11 284.08L628.67 175.68C636.62 179.57 645.37 181.61 654.16 181.61C686.14 181.61 712.15 155.6 712.15 123.63C712.15 91.66 686.14 65.66 654.16 65.66C622.2 65.66 596.19 91.66 596.19 123.63C596.19 131.59 597.85 139.53 601.01 146.8L490.99 255.66C483.89 262.69 474.46 266.56 464.46 266.56H392.93V230.76H432.59C447.43 230.76 461.43 225.03 472.03 214.63L491.36 195.64C502.05 185.12 508.18 170.49 508.18 155.5V141.87C530.7 133.56 546.16 111.65 546.16 87.45C546.16 55.48 520.15 29.47 488.19 29.47C456.22 29.47 430.22 55.48 430.22 87.45C430.22 111.65 445.68 133.55 468.2 141.87V155.5C468.2 159.84 466.42 164.08 463.32 167.13L444.01 186.11C440.94 189.12 436.88 190.78 432.59 190.78H392.93V90.6C392.93 40.64 352.28 0 302.32 0H285.46C227.58 0 175.64 33.91 152.4 86.62C128.61 90.35 107.17 101.5 90.27 118.96C70.2 139.71 59.14 167.03 59.14 195.89C59.14 205.06 60.25 214.11 62.44 222.86C24.38 241.24 0 279.93 0 322.51C0 366.67 25.7 406.01 65.77 423.69C65.38 427.51 65.19 431.33 65.19 435.08C65.19 460.62 74.06 485.53 90.17 505.21C105.65 524.13 127.15 537.45 150.92 542.9C161.64 570.3 180.32 595.01 203.75 612.71C231.72 633.85 265.07 645.02 300.21 645.02H317.08C358.9 645.02 392.93 610.99 392.93 569.16V455.07H474.96C478.04 455.07 481 456.02 483.51 457.8L532.18 492.54C541.52 499.19 552.5 502.71 563.95 502.71H582.75C591.06 525.24 612.97 540.7 637.17 540.7C669.13 540.7 695.14 514.69 695.14 482.72C695.14 450.75 669.13 424.75 637.17 424.75C612.97 424.75 591.06 440.21 582.75 462.73H563.95C560.88 462.73 557.92 461.78 555.4 460L506.73 425.26C497.39 418.61 486.41 415.09 474.96 415.09H392.93V381.84H535.69ZM678.73 288.43C688.66 288.43 696.74 296.51 696.74 306.44C696.74 316.36 688.66 324.43 678.73 324.43C669.96 324.43 662.5 318.17 661.01 309.55L660.94 309.1C660.8 308.25 660.74 307.38 660.74 306.44C660.74 296.51 668.81 288.43 678.73 288.43ZM654.16 105.64C664.09 105.64 672.17 113.71 672.17 123.63C672.17 133.56 664.09 141.64 654.16 141.64C649.16 141.64 644.52 139.62 641.07 135.96C637.91 132.61 636.17 128.23 636.17 123.63C636.17 113.71 644.24 105.64 654.16 105.64ZM488.19 69.45C498.11 69.45 506.18 77.52 506.18 87.45C506.18 97.37 498.11 105.44 488.19 105.44C478.27 105.44 470.2 97.37 470.2 87.45C470.2 77.52 478.27 69.45 488.19 69.45ZM317.08 605.04H300.21C257.23 605.04 216.83 581.26 195.58 543.95C247.83 534.53 286.47 488.82 286.47 435.08C286.47 420.72 283.75 406.74 278.38 393.53C276.37 388.58 272.55 384.71 267.62 382.63C262.7 380.57 257.27 380.53 252.34 382.54C247.4 384.55 243.53 388.37 241.46 393.29C239.38 398.21 239.34 403.64 241.35 408.58C244.76 416.98 246.49 425.9 246.49 435.08C246.49 474.04 214.79 505.73 175.84 505.73C173.19 505.73 170.62 505.6 168.2 505.32L167.76 505.28C132.06 501.23 105.17 471.1 105.17 435.08C105.17 428.66 106.03 422.27 107.73 416.08L107.97 415.37V415.25C116.71 385.28 144.53 364.41 175.84 364.41C179.49 364.41 183.14 364.69 186.7 365.25C197.59 366.91 207.83 359.42 209.51 348.54C211.18 337.63 203.68 327.4 192.81 325.74C187.25 324.87 181.54 324.43 175.84 324.43C134.28 324.43 96.08 347.98 77.25 384.82C54.47 372.65 39.98 348.65 39.98 322.51C39.98 295.55 55.21 271.11 79.09 259.23C99.66 288.5 134.05 306.54 169.79 306.54C171.87 306.54 173.97 306.47 176.01 306.35C187.01 305.73 195.46 296.27 194.83 285.28C194.23 274.28 184.8 265.84 173.76 266.44C172.34 266.52 171.04 266.56 169.79 266.56C142.64 266.56 117.57 250.7 105.92 226.16C101.41 216.66 99.12 206.47 99.12 195.89C99.12 157.77 128.87 126.81 166.9 125.29C167 125.3 167.1 125.3 167.2 125.29H167.44L167.58 125.28C168.31 125.24 169.04 125.23 169.79 125.23C208.75 125.23 240.44 156.93 240.44 195.89C240.44 206.77 238.05 217.18 233.32 226.84C230.97 231.64 230.63 237.06 232.37 242.11C234.1 247.16 237.7 251.23 242.48 253.57C245.19 254.9 248.22 255.61 251.26 255.61C258.95 255.61 265.84 251.32 269.23 244.4C276.66 229.24 280.42 212.92 280.42 195.89C280.42 144.9 245.55 100.73 196.62 88.54C215.86 58.44 249.36 39.98 285.46 39.98H302.32C330.24 39.98 352.95 62.69 352.95 90.6V569.16C352.95 588.94 336.86 605.04 317.08 605.04ZM637.17 464.73C647.09 464.73 655.16 472.8 655.16 482.72C655.16 492.65 647.09 500.73 637.17 500.73C627.25 500.73 619.17 492.65 619.17 482.72C619.17 472.8 627.25 464.73 637.17 464.73Z"
						fill="#587DA8"
					/>
				</g>
				<defs>
					<clipPath id="clip0_107_159">
						<rect width="736.71" height="645.02" fill="white" />
					</clipPath>
				</defs>
			</svg>

			<div class="text">
				<p>
					Consulting services that support your digital transformation journey —
					helping your business redefine processes, adopt modern technologies,
					and implement strategies that drive innovation and growth.
				</p>
			</div>
		</div>
	</div>
</template>
<script setup>
import brain from "@/assets/images/Frame2.svg";
</script>
<style scoped lang="scss">
.info-wrap {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	max-width: $content-max-width;
	margin: 4rem auto;
	padding: 4rem 0;

	// .narrow {
	// max-width: 350px !important;
	// }

	.info {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 460px;
		margin: 2rem 1rem;

		&:first-child {
			margin: 0 1rem 2rem;
		}

		@media screen and (width >= 768px) {
			margin: 4rem 1rem;
			font-size: 18px;

			&:first-child {
				margin: 4rem 1rem;
			}
		}

		&:hover {
			svg {
				transform: scale(1.1);
			}
		}

		/* stylelint-disable-next-line no-descending-specificity */
		svg {
			height: 60px;
			transition-duration: 0.3s;
			margin-bottom: 1rem;

			:deep() {
				path {
					fill: $second-app-color;
				}
			}

			@media screen and (width >= 768px) {
				margin-bottom: 2rem;
			}
		}

		.text {
			text-align: center;
			width: 80%;
		}
	}
}

.mobile {
	@media screen and (width > 768px) {
		display: none !important;
	}
}

.desktop {
	@media screen and (width <= 768px) {
		display: none !important;
	}
}

@media screen and (width <= 700px) {
	.info-wrap {
		padding: 0;
		margin-top: 0;
	}
}

@media screen and (width <= 500px) {
	.info {
		flex-direction: column !important;
		text-align: left;

		img {
			margin-right: 0 !important;
		}

		.text {
			margin-top: 2rem;
			width: 90% !important;
			text-align: center;
		}
	}
}
</style>
